/* eslint-disable no-magic-numbers */

import { ApiFn, resourceCache } from "use-async-resource";

type StatusCode = number;

export class ResourceError<T extends ApiFn<unknown, any[]>> extends Error {
  resource: T;
  body?: any;
  constructor(resource: T, message: string, body?: any) {
    super(message);
    this.body = body;
    this.resource = resource;
  }
  clear() {
    resourceCache(this.resource).clear();
  }
}

export class FetchWithCode<
  T extends ApiFn<unknown, any[]>
> extends ResourceError<T> {
  code!: StatusCode;
  setCode(code: StatusCode): this {
    this.code = code;
    return this;
  }
}

export function isFetchWithCode<T extends ApiFn<unknown, any[]>>(
  error: unknown
): error is FetchWithCode<T> {
  return error instanceof FetchWithCode;
}

export function isFetchGoneRequest<T extends ApiFn<unknown, any[]>>(
  error: unknown
): error is FetchWithCode<T> {
  return isFetchWithCode(error) && error.code === 410;
}

export class FetchFailedRequest<
  T extends ApiFn<unknown, any[]>
> extends ResourceError<T> {}

export class FetchBadRequest<
  T extends ApiFn<unknown, any[]>
> extends ResourceError<T> {
  code = 400;
}

export class FetchUnauthorizedRequest<
  T extends ApiFn<unknown, any[]>
> extends ResourceError<T> {
  code = 401;
}

export class FetchForbiddenRequest<
  T extends ApiFn<unknown, any[]>
> extends ResourceError<T> {
  code = 403;
}

export class FetchNotFoundRequest<
  T extends ApiFn<unknown, any[]>
> extends ResourceError<T> {
  code = 404;
}

export class FetchConflictRequest<
  T extends ApiFn<unknown, any[]>
> extends ResourceError<T> {
  code = 409;
}

export function isFetchNotFoundRequest<T extends ApiFn<unknown, any[]>>(
  error: unknown
): error is FetchNotFoundRequest<T> {
  return error instanceof FetchNotFoundRequest;
}

export class FetchInternalServerError<
  T extends ApiFn<unknown, any[]>
> extends ResourceError<T> {
  code = 500;
}

export class NetworkRequestFailed<
  T extends ApiFn<unknown, any[]>
> extends ResourceError<T> {
  code = 999;
}

export class CreateQRReaderWorkerError extends Error {}
